import React from 'react'
import classNames from 'classnames'
import CKEditor from '../editor'
import { plainTextLength } from './enrollmentValidation'

/** Plain-text length of CKEditor HTML — visible code points (emoji = 1). */
export const stripHtmlLength = (html) => plainTextLength(html)

/**
 * Experience v7 CKEditor chrome — shell + optional char-count foot.
 * Does not block typing past maxLength; parent validates on blur.
 */
const ExperienceCKEditor = ({
  data,
  maxLength,
  className,
  onReady,
  onChange,
  ...rest
}) => {
  const charCount = typeof maxLength === 'number' ? stripHtmlLength(data) : null
  const overLimit =
    typeof maxLength === 'number' && charCount != null && charCount > maxLength

  return (
    <div
      className={classNames('experience-editor-shell', className, {
        'has-error': overLimit,
      })}>
      <CKEditor
        data={data || ''}
        onReady={onReady}
        onChange={onChange}
        {...rest}
      />
      {typeof maxLength === 'number' ? (
        <div className='experience-editor-foot'>
          <span
            className={classNames('experience-char-count', {
              error: overLimit,
            })}>
            {charCount} / {maxLength}
          </span>
        </div>
      ) : null}
    </div>
  )
}

export default ExperienceCKEditor
